import logo from '../assets/logo.png'

const HOME_URL = 'https://www.ridebelay.com/'

export const Header = (): JSX.Element => (
  <header className='col-span-12 bg-white md:bg-inherit pl-5 md:pl-9 lg:pl-5 xl:pl-9'>
    <a className='inline-block' href={HOME_URL}>
      <img className='inline w-12 md:w-14' src={logo} />
      <h1 className='-ml-1 inline font-extrabold text-2xl md:text-3xl align-middle text-brand-purple'>
        Belay
      </h1>
    </a>
  </header>
)
